import { getLoaderEndpoint } from "@app/framework/loader";
import { pageHead } from "@app/framework/meta";
import { boardOfDirectorsAtom } from "@modules/board-of-directors/atoms";
import { BoardOfDirectorsPage } from "@modules/board-of-directors/pages";
import { getBoardOfDirectorsService } from "@modules/board-of-directors/services";
import { trans } from "@mongez/localization";
import { LoaderFunctionArgs, MetaFunction } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";

export async function loader({ request }: LoaderFunctionArgs) {
  const { http, success, catchErrors } = await getLoaderEndpoint(request);

  try {
    const response = await getBoardOfDirectorsService(http);

    return success(response);
  } catch (error) {
    return catchErrors(error);
  }
}

export default function BoardOfDirectorsIndex() {
  const { boardOfDirectors } = useLoaderData<typeof loader>();

  boardOfDirectorsAtom.update({
    boardOfDirectors: boardOfDirectors.boardOfDirectors,
    executiveManagement: boardOfDirectors.executiveManagement,
  });

  return <BoardOfDirectorsPage />;
}

export const meta: MetaFunction = () => {
  return pageHead({
    title: trans("boardOfDirectors"),
    appendAppName: true,
  });
};
